import { GET_PRODUCT_LOCATIONS } from "../../type/productLocations";
// **  Initial State
const initialState = {
  data: [],
  totalRecords: 0,
  totalPages: 1,
  percentage: 0,
  params: {},
};

const productLocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCT_LOCATIONS:
      return {
        ...state,
        data: action.payload.results,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalResults,
        params: { limit: action.payload.limit, page: action.payload.page },
      };
    default:
      return state;
  }
};

export default productLocationReducer;
